import React from "react";
import { MenuItem, ClickAwayListener } from "@mui/material";
import { DropdownBox } from "src/scenes/Chat/components/styled/chatMessagesStyled";
import styled from "styled-components";

const CursorMenuItem = styled(MenuItem)`
    cursor: pointer;
`;

const DropdownActionsBox = (props) => {
    return (
        <ClickAwayListener onClickAway={() => props.setToggleDropdown(false)}>
            <DropdownBox >
                <MenuItem weight="500"
                    padding="0 0 0 1.0625rem"
                    onClick={() => props.showUserProfile()}    
                >
                    View Profile
                </MenuItem>
                <CursorMenuItem
                    weight="500"
                    padding="0 0 0 1.0625rem"
                    onClick={() => props.deleteChat()}
                >
                    Delete Chat
                </CursorMenuItem>
            </DropdownBox>
        </ClickAwayListener>
    );
};

export default DropdownActionsBox;
